// extracted by mini-css-extract-plugin
export var deleteIcon = "_ps-5";
export var deleteOption = "_ps-3";
export var divider = "_ps-2";
export var downloadIcon = "_ps-4";
export var drawer = "_ps-0";
export var drawerFooter = "_ps-6";
export var drawerOpen = "_ps-1";
export var highlighted = "_ps-7";
export var lighterHighlight = "_ps-8";